import React from 'react';

function ClaimStatistics() {
  return (
    <div className="card border-0 shadow-sm" data-aos="fade-left" data-aos-delay="100">
      <div className="card-body p-4">
        <h6 className="mb-3 fw-bold text-center">Claim Statistics</h6>
        
        <div className="text-center mb-3">
          <select className="form-select form-select-sm" style={{ maxWidth: '200px', margin: '0 auto' }}>
            <option>Filter by: All time</option>
            <option>Last 30 days</option>
            <option>Last 6 months</option>
            <option>Last year</option>
          </select>
        </div>

        <div className="text-center py-4">
          <p className="text-muted small mb-1">Total Claims</p>
          <h2 className="mb-0 fw-bold" style={{ color: '#F89423' }}>0</h2>
        </div>
      </div>
    </div>
  );
}

export default ClaimStatistics;